import { of } from 'rxjs'
import { map } from 'rxjs/operators'
import { useObservable } from '@cicero/ui'
import { AttributeSchema } from '../AttributeSchema'
import { useModel } from './useModel'
import { sortByIdList } from '../filters'

export const useAttributesInOrder = (ids?: string[]) => {
  const Attributes = useModel(AttributeSchema)
  const displayAttributes = useObservable(
    () => ids && ids.length
      ? Attributes.QUERY$(AttributeSchema.QUERIES.queryIds(ids))
        .pipe(
          map(r => sortByIdList(r, ids))
        )
      : of([]),
    [], [ids]
  )

  return displayAttributes
}
